import { RatingSummary } from "@interfaces/dto/review.dto";


interface PropsReview {
  totalReviews: number;
  reviewSummary: RatingSummary[];
}

interface PropsProgress {
  reviewSummary: RatingSummary[];
}

interface CalculateStarRatingResult {
  starAverage: number;
  starText: string;
}

interface ProgressRating {
  ratefive: number;
  ratefour: number;
  ratethree: number;
  ratetwo: number;
  rateone: number;
  progressWidthFive: string;
  progressWidthFour: string;
  progressWidthThree: string;
  progressWidthTwo: string;
  progressWidthOne: string;
}

export const calculateStarRating = (props: PropsReview): CalculateStarRatingResult => {
  const totalReviews = props.totalReviews;
  const reviewSummary = props.reviewSummary;

  const starAverage =
  totalReviews > 0
    ? reviewSummary.reduce((total, summary) => total + summary.rating_star * summary.total_count, 0) /
    totalReviews
    : 0;
    
  let starText = "";
  if (starAverage === 5) {
    starText = "ดีเยี่ยม";
  } else if (starAverage >= 4) {
    starText = "ดีมาก";
  } else if (starAverage >= 3) {
    starText = "ดี";
  } else if (starAverage >= 2) {
    starText = "พอใช้";
  } else if (starAverage >= 1) {
    starText = "ปานกลาง";
  } else {
    starText = "ไม่มีคะแนน";
  }
  return { starAverage, starText };
};

export const progressBarReview = (props: PropsProgress): ProgressRating => {
  const ratefive = props.reviewSummary.find((review) => review.rating_star === 5)?.total_count || 0;
  const ratefour = props.reviewSummary.find((review) => review.rating_star === 4)?.total_count || 0;
  const ratethree = props.reviewSummary.find((review) => review.rating_star === 3)?.total_count || 0;
  const ratetwo = props.reviewSummary.find((review) => review.rating_star === 2)?.total_count || 0;
  const rateone = props.reviewSummary.find((review) => review.rating_star === 1)?.total_count || 0;

  const totalReviewCount = props.reviewSummary.reduce((total, review) => total + review.total_count, 0);

  let progressWidthFive = totalReviewCount > 0 ? `${(ratefive / totalReviewCount) * 100}%` : '0%';
  let progressWidthFour = totalReviewCount > 0 ? `${(ratefour / totalReviewCount) * 100}%` : '0%';
  let progressWidthThree = totalReviewCount > 0 ? `${(ratethree / totalReviewCount) * 100}%` : '0%';
  let progressWidthTwo = totalReviewCount > 0 ? `${(ratetwo / totalReviewCount) * 100}%` : '0%';
  let progressWidthOne = totalReviewCount > 0 ? `${(rateone / totalReviewCount) * 100}%` : '0%';

  return {
    ratefive,
    ratefour,
    ratethree,
    ratetwo,
    rateone,
    progressWidthFive,
    progressWidthFour,
    progressWidthThree,
    progressWidthTwo,
    progressWidthOne,
  };
};
